var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"skeletons-TextSkeleton bg-skeleton leading-skeleton",class:{'animate-pulse': _vm.pulse},attrs:{"data-test":"characters"},domProps:{"innerHTML":_vm._s(_setup.spaceChars)}})
}
var staticRenderFns = []

export { render, staticRenderFns }